export default __webpack_public_path__ + "static/media/eth-svgrepo-com.e220d382.svg";